
'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

export function HashScrollHandler() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        // Check if there is a hash in the URL
        const hash = window.location.hash;
        if (hash) {
            // Remove the '#' and strip any embedded query string
            // (e.g. "#join-us-form?from=ig-campaign-2" -> "join-us-form").
            const id = hash.substring(1).split('?')[0];

            // Delay scrolling to ensure content is loaded (requested roughly 1 sec delay)
            const timer = setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    console.log('[HashScrollHandler] Scrolling to:', id);
                    element.scrollIntoView({ behavior: 'smooth' });
                } else {
                    console.warn('[HashScrollHandler] Element not found:', id);
                }
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [pathname, searchParams]); // Re-run on route change

    return null;
}
